import { forwardRef, InputHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';
import InputElement from './input-element';
import { InputErrorSpan } from './input-error-span';
import { InputLabel } from './input-label';

type SimpleInputProps = {
  label: string;
  type: 'email' | 'text' | 'select' | 'number' | 'checkbox' | 'password';
  name: string;
  error?: FieldError;
  handleHelperButtonClick?: () => void;
  helperButtonLabel?: string;
} & InputHTMLAttributes<HTMLInputElement>;

const SimpleInput = forwardRef<HTMLInputElement, SimpleInputProps>(
  (props: SimpleInputProps, ref: React.Ref<HTMLInputElement>) => {
    const { name, label, error, ...rest } = props;

    return (
      <div className="flex flex-col max-w-full min-w-max">
        {label && <InputLabel htmlFor={name} label={label} />}
        <InputElement {...rest} ref={ref} id={name} name={name} error={error} />
        <InputErrorSpan message={error?.message} />
      </div>
    );
  },
);

SimpleInput.displayName = 'SimpleInput';

export default SimpleInput;
